import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { ConnectTokenRequestInterceptor } from './lib/connect-token-request.interceptor';

export * from './lib/connect-token-request.interceptor';

export function provideConnectTokenRequest(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ConnectTokenRequestInterceptor,
      multi: true,
    },
  ]);
}
